
import {
  computed,
  defineComponent,
  reactive,
  ref,
  nextTick,
  onMounted,
  toRefs,
  watch,
} from "vue";
import { IUserActivity, IUser } from "@/interfaces/iUser";
import { IDataTableFilterOption } from "@/interfaces/iPageModel";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { PAGINATION } from "@/helpers/pagination";
import { TranslationService } from "@/core/services/TranslationService";
import { FormatMethods } from "@/helpers/data-format";
import { UserAPI } from "@/services/api/User.service";
import { DrawerComponent } from "@/assets/ts/components";
const isFullScreen = ref<boolean>(false);
const currentWidth = computed(() => {
  return isFullScreen.value
    ? "{default:'100%', 'sm': '100%', 'md': '100%', 'lg': '100%', 'xl': '100%'}"
    : "{default:'400px', 'sm': '550px', 'md': '768px', 'lg': '992px', 'xl': '1200px'}";
});
import {
  userActivityTableHeaders,
  userActivityTableFilters,
} from "../dataTableOptions";
export default defineComponent({
  name: "roleActivity",
  components: { Datatable },
  props: {
    viewName: { type: String, default: "" },
    type: { type: String, default: "" },
    icon: { type: String, default: "" },
    refresh: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const localPagination = reactive(PAGINATION);
    function t(key: string) {
      return TranslationService.translate(key);
    }
    const rowsPerPage = ref(20);
    const loading = ref(false);
    const showSearch = true;
    const { viewName, type, refresh } = toRefs(props);
    const tableData = ref<IUserActivity[]>([]);
    const tableHeader = ref(userActivityTableHeaders());
    const tableFilter = ref<Array<IDataTableFilterOption>>(
      userActivityTableFilters()
    );
    const format = computed(() => {
      return FormatMethods;
    });
    const syncQuery = async (params?: Record<string, number | string>) => {
      queryUpdate(params);
    };
    const queryUpdate = async (params?: any) => {
      try {
        // loading.value = true;
        params = {
          ...params,
          type: type.value,
          sort: params && params.sort ? params.sort : "createdDate,desc",
          startDate: params?.startDate === null ? [] : params?.startDate,
        };
        const data = await UserAPI.getInstance().getRoleActivity({ ...params });
        tableData.value = [...data.content];
        localPagination.total = data.totalElements;
        rowsPerPage.value = data.size;
        localPagination.page = ++data.number;
      } finally {
        // loading.value = false;
      }
    };

    const handleResize = () => {
      isFullScreen.value = !isFullScreen.value;
      nextTick(() => {
        DrawerComponent?.getInstance("kt_lookup_drawer")?.update();
      });
    };
    onMounted(() => {
      var button = document.getElementById("kt_lookup_drawer_toggle-activity");
      if (button) {
        button.addEventListener("click", function () {
          if (viewName.value == "Roles Activity Pulse") {
            queryUpdate({
              page: localPagination.page - 1,
              size: rowsPerPage.value,
            });
          }
        });
      }

      var drawerElement = document.getElementById("kt_lookup_drawer");
      drawerElement?.addEventListener("transitionend", function (event) {
        if (event?.propertyName === "transform") {
          const targetElement = event.target as HTMLElement;
          if (targetElement.className === "drawer drawer-end drawer-on") {
            // queryUpdate({
            //   page: localPagination.page - 1,
            //   size: rowsPerPage.value,
            // });
          }
        }
      });
      tableData.value = [];
      // queryUpdate({
      //   page: localPagination.page - 1,
      //   size: rowsPerPage.value,
      // });
      watch(
        refresh,
        (newValue) => {
          if (newValue === true) {
            tableData.value = [];
            queryUpdate({
              page: localPagination.page - 1,
              size: rowsPerPage.value,
            });
          }
        },
        {
          deep: true,
        }
      );
    });
    return {
      format,
      tableData,
      tableHeader,
      tableFilter,
      showSearch,
      rowsPerPage,
      loading,
      localPagination,
      t,
      syncQuery,
      handleResize,
      currentWidth,
    };
  },
});
